import React from 'react';

const Intro = () => {
  return (
    <section id="intro">
      <div id="intro-content">
        <h2>¡Hola, bienvenido/a a Framegonz!</h2>
        <p>
          Soy técnico especializado en administración de sistemas informáticos, desarrollo de aplicaciones, soporte técnico, creación de páginas web y apps para móviles.<br/><br/>
          Con años de experiencia en el sector, mi misión es ayudarte a optimizar tu infraestructura tecnológica, desarrollar soluciones personalizadas que se ajusten a tus necesidades y ofrecer un soporte técnico fiable, ya sea presencial en la isla de Tenerife o de forma remota en toda España.<br/><br/>
          He tenido el privilegio de colaborar con empresas de diversos sectores, proporcionando soluciones que mejoran la eficiencia, seguridad y desempeño de sus sistemas y plataformas digitales.<br/><br/>
          Si buscas un profesional comprometido, con un enfoque en resultados, atención cercana y orientado al cliente, ¡estoy aquí para ayudarte a alcanzar tus objetivos tecnológicos!<br/><br/>
        </p>
        <a href="#contact" className="intro-link">Contáctame si quieres que forme parte de tu proyecto.</a>
        <p>
          <br/>"Optimizando tu tecnología, impulsando tu futuro."
        </p>
      </div>
    </section>
  );
};

export default Intro;